import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { addDefaultsMaterials } from "#modules/materials/infra/addDefaultsMaterials.api";
import { customMaterialsQuery } from "#modules/materials/infra/customMaterials.query";
import { materialsVolumetricPriceQuery } from "#modules/materials/infra/materialsVolumetricPrice.query";

export const useAddDefaultsMaterials = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: addDefaultsMaterials,
    onSuccess: () => {
      void queryClient.invalidateQueries(customMaterialsQuery());
      void queryClient.invalidateQueries(materialsVolumetricPriceQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { addDefaultsMaterials: mutateAsync, isPending };
};
